import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';
import classNames from 'classnames';

const XMarkRectangleIcon: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={classNames(className)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        style={customStyle}
        fill="none"
        viewBox="0 0 18 17"
      >
        <path
          fill="currentColor"
          d="M16.12 1.58C15.213.673 13.965.497 12.365.497H5.6c-1.574 0-2.83.185-3.727 1.081C.967 2.484.8 3.724.8 5.306v6.706c0 1.6.167 2.839 1.063 3.744.914.896 2.162 1.072 3.762 1.072h6.741c1.6 0 2.848-.176 3.753-1.072.905-.905 1.072-2.145 1.072-3.744V5.323c0-1.6-.167-2.847-1.072-3.744m-.651 3.506v7.163c0 .914-.123 1.758-.607 2.241-.492.492-1.344.615-2.25.615H5.38c-.905 0-1.758-.123-2.25-.615-.492-.483-.607-1.327-.607-2.241V5.104c0-.932.115-1.776.598-2.268.492-.492 1.354-.615 2.276-.615h7.216c.906 0 1.758.132 2.25.615.492.492.607 1.336.607 2.25m-9.36 7.26c.228 0 .421-.08.57-.238L9 9.788l2.33 2.32c.149.15.333.238.57.238a.79.79 0 0 0 .554-1.354l-2.329-2.329 2.338-2.338a.76.76 0 0 0 .237-.554.79.79 0 0 0-.79-.79c-.22 0-.396.079-.563.246L9 7.556l-2.33-2.32a.74.74 0 0 0-.562-.238.78.78 0 0 0-.79.782c0 .211.087.405.237.554l2.329 2.33L5.554 11a.74.74 0 0 0-.237.545c0 .448.352.8.791.8"
        ></path>
      </svg>
    </div>
  );
};

export default XMarkRectangleIcon;
